import React, { useState, useRef, useEffect } from "react";
import { useFormik } from "formik";
import {
  Button,
  Form,
  Input,
  Label,
  Textarea,
  ErrorText,
} from "../../../styledComponent";
import styles from "./style.module.scss";
import { wholesaleBusinessContactFormInitialValues } from "../../../../utils/formik/initialvalue";
import { wholesaleBusinessContactFormValidationSchema } from "../../../../utils/formik/validationSchema";
import { handleApiErrors, normalizeInput } from "../../../../utils/helpers";
import { toast } from "react-toastify";
import { BASE_URL, POST_API_URLS } from "../../../../utils/apiConstant";
import axios from "axios";

const WholesaleBusinessContactForm = (props) => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const formikRef = useRef(null);
  const formik = useFormik({
    initialValues: wholesaleBusinessContactFormInitialValues,
    validationSchema: wholesaleBusinessContactFormValidationSchema,
    onSubmit: (values) => formSubmitHandler(values),
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      formikRef.current = formik;
      formikRef.current.setFieldValue("phone", phoneNumber);
    }, 1000);
    return () => clearTimeout(timer);
  }, [phoneNumber, formik]);

  async function formSubmitHandler(data) {
    props.loader(true);
    const requestedData = {
      full_name: data.name,
      email: data.email,
      phone_number: data.phone,
      message: data.message,
    };
    try {
      await axios.post(
        `${BASE_URL + POST_API_URLS.WHOLESALE_BUSINESS_FORM}`,
        requestedData
      );
      props.loader(false);
      props.success(true);
    } catch (error) {
      props.loader(false);
      props.loader(false);
      const errorMessages = handleApiErrors(error);
      // Display each error in a separate snackbar
      errorMessages.forEach(({ field, message }) => {
        const formattedMessage = field ? `${field}: ${message}` : message; // Include field name if available
        toast.error(formattedMessage, {
          position: "top-center",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "colored",
          style: { fontSize: "1.4rem", fontWeight: 500 },
        });
      });
    }
  }

  return (
    <Form onSubmit={formik.handleSubmit} className={styles.becomeDealerForm}>
      <div>
        <div>
          <Label htmlFor="name">Full Name*</Label>
          <Input
            type="text"
            id="name"
            {...formik.getFieldProps("name")}
            style={
              formik.touched.name &&
              formik.errors.name && {
                boxShadow: "0px 0px 0px 2px red",
              }
            }
          />
          {formik.touched.name && formik.errors.name && (
            <ErrorText className={styles.errorText}>
              {formik.errors.name}
            </ErrorText>
          )}
        </div>
      </div>
      <div>
        <div>
          <Label htmlFor="phone">Phone Number</Label>
          <Input
            type="text"
            name="phone"
            id="phone"
            placeholder="(xxx) xxx-xxxx"
            onBlur={formik.handleBlur("phone")}
            onChange={(e) => {
              setPhoneNumber((prev) => normalizeInput(e.target.value, prev));
            }}
            value={phoneNumber}
            style={
              formik.touched.phone &&
              formik.errors.phone && { boxShadow: "0px 0px 0px 2px red" }
            }
          />
          {formik.touched.phone && formik.errors.phone && (
            <ErrorText className={styles.errorText}>
              {formik.errors.phone}
            </ErrorText>
          )}
        </div>
      </div>
      <div>
        <div>
          <Label htmlFor="email">Email Address*</Label>
          <Input
            type="email"
            id="email"
            {...formik.getFieldProps("email")}
            style={
              formik.touched.email &&
              formik.errors.email && { boxShadow: "0px 0px 0px 2px red" }
            }
          />
          {formik.touched.email && formik.errors.email && (
            <ErrorText className={styles.errorText}>
              {formik.errors.email}
            </ErrorText>
          )}
        </div>
      </div>
      <div>
        <div>
          <Label htmlFor="message">Message*</Label>
          <Textarea
            id="message"
            rows={4}
            cols={50}
            {...formik.getFieldProps("message")}
            style={
              formik.touched.message &&
              formik.errors.message && { boxShadow: "0px 0px 0px 2px red" }
            }
          ></Textarea>
          {formik.touched.message && formik.errors.message && (
            <ErrorText className={styles.errorText}>
              {formik.errors.message}
            </ErrorText>
          )}
        </div>
      </div>
      <Button
        $width="100%"
        type="submit"
        className={
          !(formik.isValid && formik.dirty) ? "disabledBtn" : "submitBtn"
        }
      >
        Submit
      </Button>
    </Form>
  );
};

export default WholesaleBusinessContactForm;
